import WebHttpClient from '~src/httpClient/WebHttpClient';
import {
  DeleteSiteEncryptionKeyRequest,
  IDeleteSiteEncryptionKeyResult
} from '~src/kmsInOnline/serverApi/DeleteSiteEncryptionKeyRequest';

export function deleteSiteEncryptionKey(): Promise<IDeleteSiteEncryptionKeyResult> {
  return WebHttpClient.sendRequest(new DeleteSiteEncryptionKeyRequest({}));
}

export const DeleteSiteEncryptionKeyService = {
  deleteSiteEncryptionKey: deleteSiteEncryptionKey
};